<div class="grid grid-cols-12 step-master-container py-4 lg:py-0">
  <div class="col-span-4 hidden lg:block h-full">
    <div class="step-wrapper">
      <img src="assets/diagnose_hero.png" alt="stepper" class="step-image" />
    </div>
  </div>
  <div class="col-span-12 lg:col-span-8 w-full">
    @if (!isVDR) {
      <div class="step-horizontal">
        <p-steps [model]="initialStepper()" [readonly]="true" class="w-full" styleClass="step-horizontal-item w-full" />
      </div>
    }
  </div>
</div>
